import React, { useEffect, useState } from "react";

import { Box, Typography, TextField, Button } from "@mui/material";
import { translate } from "i18n";
import { LicenseStringModel, WatermarkingConfigurationInkModel, WatermarkingConfigurationModel } from "acr-common-models";
import { acrAPI } from "utils/api";

import { Subscription } from "rxjs";
import { object, number, string } from "yup";
import { Formik, Form, Field, FormikTouched, useFormik, FormikProps } from "formik";
import { CustomDialog } from "components/CustomDialog";
import { LicenseInformation } from "components/Maintenance/LicenseInformation";


export function WatermarkingSettings(props: any): React.ReactElement{
  const validationSchema = () => object({
    configSnap: object().shape({
      heartbeatMin: number()
        .required("The heartbeat value is needed")
        .min(1, "Value should be between 1 and 720")
        .max(720, "Value should be between 1 and 720"),
      minTimeCodeDrift: number()
        .required("A minimum time code drift value is needed")
        .min(-3600, "Value should be between -3600 and -2")
        .max(-2, "Value should be between -3600 and -2"),
      maxTimeCodeDrift: number()
        .required("A maximum time code drift value is needed")
        .min(2, "Value should be between 2 and 3600")
        .max(3600, "Value should be between 2 and 3600"),
      nbEvent: number()
        .required("Number of event occurence value is needed")
        .min(1, "Value should be between 1 and 40")
        .max(40, "Value should be between 1 and 40"),
      nbRestartAlarm: number()
        .required("Number of restart alarm value is needed")
        .min(1, "Value should be between 1 and 20")
        .max(20, "Value should be between 1 and 20"),
    }),
    configInk: object().shape({
      heartbeatMin: number()
        .required("The heartbeat value is needed")
        .min(1, "Value should be between 1 and 720")
        .max(720, "Value should be between 1 and 720"),
    }),
    licenseInk: object().shape({
      content: string(),
    }),
    licenseSnap: object().shape({
      content: string(),
    })
    });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [configSnap, setConfigSnap] = useState({ id: 0, heartbeatMin: 10, minTimeCodeDrift: -60, maxTimeCodeDrift: 60, nbEvent: 2, nbRestartAlarm: 1, technology: "snap" })
  const [configInk, setConfigInk] = useState({ id: 0, heartbeatMin: 10, technology: "ink" })
  const [licenseSnap, setLicenseSnap] = useState({id:0, content: "",technology:"snap"});
  const [licenseInk, setLicenseInk] = useState({id:0, content: "",technology:"ink"});
  //private valuesToSubmit: any;

  const openRestartConfirmation = (): void => {
    setDialogOpen(true);
  }
  const closeRestartConfirmation = (): void => {
    setDialogOpen(false);
  }

  useEffect(() => {
    setConfigSnap({ id: 0, heartbeatMin: 10, minTimeCodeDrift: -60, maxTimeCodeDrift: 60, nbEvent: 2, nbRestartAlarm: 1, technology: "snap" });
    setConfigInk({ id: 0, heartbeatMin: 10, technology: "ink" });   
    const configurationSnapSub = acrAPI.watermarkingConfigurationSubjectSnap.subscribe(updateConfigurationSnap);
    const configurationInkSub = acrAPI.watermarkingConfigurationSubjectInk.subscribe(updateConfigurationInk);
    const licenseSnapSub = acrAPI.licenseStringSubjectSnap.subscribe(updateLicenseStringSnap);
    const licenseInkSub = acrAPI.licenseStringSubjectInk.subscribe(updateLicenseStringInk);
    acrAPI.getLicenseStringByTechno("snap");
    acrAPI.getLicenseStringByTechno("ink");
    acrAPI.getWatermarkingConfigurationByTechno("snap");
    acrAPI.getWatermarkingConfigurationByTechno("ink");
    return () => {configurationSnapSub?.unsubscribe(),configurationInkSub?.unsubscribe(),licenseSnapSub?.unsubscribe(),licenseInkSub?.unsubscribe()}   
  },[]);



  const updateLicenseStringSnap = (LicenseStringModel: LicenseStringModel): void => {
    setLicenseSnap({...LicenseStringModel});
  }

  const updateLicenseStringInk = (LicenseStringModel: LicenseStringModel): void => {
    setLicenseInk({...LicenseStringModel});
  }

  const canSubmit = (errors: any, touched: FormikTouched<any>): boolean => {
    return Object.keys(errors).length === 0 && (Object.keys(touched).length > 0);
  }

  const handleSubmit = async (values: any): Promise<void> => {
    setConfigSnap(values.configSnap);
    setConfigInk(values.configInk);
    setLicenseSnap(values.licenseSnap);
    setLicenseInk(values.licenseInk);
    setDialogOpen(true);
  }

  const saveAndRestart =  async (): Promise<void> => {
    setDialogOpen(false);
    let updateResult = false;
    updateResult = await acrAPI.updateLicenseString(licenseInk);
    updateResult = await acrAPI.updateLicenseString(licenseSnap);   
    updateResult = await acrAPI.updateWatermarkingConfiguration(configSnap);
    updateResult = await acrAPI.updateWatermarkingConfiguration(configInk);
    if(updateResult) {
      await acrAPI.restart();
    }
  }
  const updateConfigurationSnap = (watermarkingConfigurationModel: WatermarkingConfigurationModel | WatermarkingConfigurationInkModel): void => {
   setConfigSnap({...watermarkingConfigurationModel as WatermarkingConfigurationModel});
  }
  const updateConfigurationInk = (watermarkingConfigurationModel: WatermarkingConfigurationModel | WatermarkingConfigurationInkModel): void => {
    setConfigInk({...watermarkingConfigurationModel as WatermarkingConfigurationInkModel});
   }


  return (
    <>
        <CustomDialog
            title={translate("Restart confirmation logs title")}
            message={translate("Restart confirmation logs text")}
            action={() => saveAndRestart()}
            open={dialogOpen}
            disableAction={false}
            handleClose={() => closeRestartConfirmation()}
            confirmLabel={"restart"}
          />
        <Formik
            initialValues={{"licenseSnap":licenseSnap,"licenseInk":licenseInk,"configSnap":configSnap,"configInk":configInk}}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={async (values, { resetForm }) => {
              await handleSubmit(values);
              resetForm({ values });
            }}
            >
            {({ handleSubmit, handleChange, setFieldTouched, touched, values, errors }) => (
              <form name="settings-snmp-configuration-form" translate="no" method="POST" onSubmit={handleSubmit}>
                
                <Box marginLeft={2} p={2} style={{ width: "50em" }}>
                <Box display="flex" flexDirection={"column"} justifyContent="space-between" width={"88em"}>
                <Box display="flex" flexDirection="row" >
                <Box marginLeft={2} p={2} style={{ width: "50em" }}>
                <Box display="flex" flexDirection={"column"} justifyContent="space-between" width={"38em"}>
                <Typography data-cy="settings-watermaking-configuration-label" variant="h4">
          {translate(values.licenseSnap.technology + " watermarking license title")}
        </Typography>
                <Box display="flex" flexDirection={"column"} justifyContent="space-between" width={"38em"}>
                <input
                hidden
                readOnly
                id={"licenseSnap.id"}
                name={"licenseSnap.id"}
                value={values.licenseSnap.id}
                />
                <Field
                  component={TextField}
                  variant="outlined"
                  margin="normal"
                  id={"licenseSnap.content"}
                  name={"licenseSnap.content"}
                  label={translate("license content")}
                  fullWidth
                  helperText={errors.licenseSnap?.content}
                  onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                    setFieldTouched("licenseSnap.content", true);
                    handleChange(e);
                  }}
                  value={values.licenseSnap.content}
                  data-cy={`snmp-community-name`}
                />      
               <LicenseInformation technology={values.licenseSnap.technology}/>
              </Box>
                <Field
                    component={TextField}
                    variant="outlined"
                    margin="normal"
                    id="configSnap.heartbeatMin"
                    name="configSnap.heartbeatMin"
                    label={translate("Heartbeat")}
                    fullWidth
                    helperText={errors.configSnap?.heartbeatMin}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                      setFieldTouched("configSnap.heartbeatMin", true);
                      handleChange(e);
                    }}
                    value={values.configSnap.heartbeatMin}
                    data-cy={`heartbeatSnap`}
                  />
                  <Field
                    component={TextField}
                    variant="outlined"
                    margin="normal"
                    id="configSnap.minTimeCodeDrift"
                    name="configSnap.minTimeCodeDrift"
                    label={translate("Minimum time code drift")}
                    fullWidth
                    helperText={errors.configSnap?.minTimeCodeDrift}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                      setFieldTouched("configSnap.minTimeCodeDrift", true);
                      handleChange(e);
                    }}
                    values={values.configSnap?.minTimeCodeDrift}
                    value={values.configSnap?.minTimeCodeDrift}
                    data-cy={`snmp-community-name`}
                  />
                  <Field
                    component={TextField}
                    variant="outlined"
                    margin="normal"
                    id="configSnap.maxTimeCodeDrift"
                    name="configSnap.maxTimeCodeDrift"
                    fullWidth
                    label={translate("Maximum time code drift")}
                    helperText={errors.configSnap?.maxTimeCodeDrift}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                      setFieldTouched("configSnap.maxTimeCodeDrift", true);
                      handleChange(e);
                    }}
                    values={values.configSnap?.maxTimeCodeDrift}
                    value={values.configSnap?.maxTimeCodeDrift}
                    data-cy={`snmp-community-name`}
                  />
                  <Field
                    component={TextField}
                    variant="outlined"
                    margin="normal"
                    id="configSnap.nbEvent"
                    fullWidth
                    name="configSnap.nbEvent"
                    label={translate("Number of event")}
                    helperText={errors.configSnap?.nbEvent}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                      setFieldTouched("configSnap.nbEvent", true);
                      handleChange(e);
                    }}
                    values={values.configSnap?.nbEvent}
                    value={values.configSnap?.nbEvent}
                    data-cy={`snmp-community-name`}
                  />
                  <Field
                    component={TextField}
                    variant="outlined"
                    margin="normal"
                    id="configSnap.nbRestartAlarm"
                    fullWidth
                    name="configSnap.nbRestartAlarm"
                    label={translate("Number of restart alarm")}
                    helperText={errors.configSnap?.nbRestartAlarm}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                      setFieldTouched("configSnap.nbRestartAlarm", true);
                      handleChange(e);
                    }}
                    values={values.configSnap?.nbRestartAlarm}
                    value={values.configSnap?.nbRestartAlarm}
                    data-cy={`snmp-community-name`}
                  />
                  </Box>
                  </Box>
                  <Box marginLeft={2} p={2} style={{ width: "50em" }}>
                  <Box display="flex" flexDirection={"column"} justifyContent="space-between" width={"38em"}>
                  <Typography data-cy="settings-watermaking-configuration-label" variant="h4">
          {translate(values.licenseInk.technology + " watermarking license title")}
        </Typography>
                  <input
                hidden
                readOnly
                id={"licenseInk.id"}
                name={"licenseInk.id"}
                value={values.licenseInk.id}
                />
                <Field
                  component={TextField}
                  variant="outlined"
                  margin="normal"
                  id={"licenseInk.content"}
                  name={"licenseInk.content"}
                  label={translate("license content")}
                  fullWidth
                  helperText={errors.licenseInk?.content}
                  onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                    setFieldTouched("licenseInk.content", true);
                    handleChange(e);
                  }}
                  value={values.licenseInk.content}
                  data-cy={`snmp-community-name`}
                />      
               <LicenseInformation technology={values.licenseInk.technology}/>
                <Field
                    component={TextField}
                    variant="outlined"
                    margin="normal"
                    id="configInk.heartbeatMin"
                    name="configInk.heartbeatMin"
                    label={translate("Heartbeat")}
                    fullWidth
                    helperText={errors.configInk?.heartbeatMin}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                      setFieldTouched("configInk.heartbeatMin", true);
                      handleChange(e);
                    }}
                    values={values.configInk.heartbeatMin}
                    value={values.configInk.heartbeatMin}
                    data-cy={`heartbeatink`}
                  />
</Box>
                  </Box>
                  </Box>
                  <Typography variant="h6" data-cy="maintenance-restart-text">{translate("Restart explanation")}</Typography>
                  <Button
                    type="submit"
                    disabled={!canSubmit(errors, touched)}
                    variant="contained"
                    data-cy="snmp-settings-configuration-save-button"
                    style={{ margin: "1.25em 0 1.5em 0em", height: "2.5em", padding: "0 2em" }}
                    color="primary">
                    {translate("Save-restart")}
                  </Button>
                  </Box>
                  </Box>
                
              </form>
            )}
          </Formik>
      </>
    );
  }
